import axios from 'axios';

// 登录请求方法
const loginreq = (method, url, params) => {
  return axios({
    method: method,
    url: url,
    // headers: {
    //     'Content-Type': 'application/x-www-form-urlencoded',
    // },
    data: params,
    traditional: true,
    // transformRequest: [
    //     function(data) {
    //         let ret = ''
    //         for (let it in data) {
    //             ret +=
    //                 encodeURIComponent(it) +
    //                 '=' +
    //                 encodeURIComponent(data[it]) +
    //                 '&'
    //         }
    //         return ret
    //     }
    // ]
  }).then(res => res.data);
};
// 通用公用方法
const req = (method, url, params) => {
  return axios({
    method: method,
    url: url,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    data: params,
    traditional: true,
    // transformRequest: [
    //     function(data) {
    //         let ret = ''
    //         for (let it in data) {
    //             ret +=
    //                 encodeURIComponent(it) +
    //                 '=' +
    //                 encodeURIComponent(data[it]) +
    //                 '&'
    //         }
    //         return ret
    //     }
    // ]
  }).then(res => res.data);
};
const wjldc = (method, url, params) => {

  return axios({
    method: method,
    url: url,

    headers: {
      'responseType': 'blob',
      "Content-Type": "application/json;charset=utf-8",
      AccessToken: sessionStorage.getItem('logintoken')


    },
    responseType: "blob",
    setHeader: {
      "Access-Control-Expose-Headers": "Content-Disposition"
    },
    data: params,
    traditional: true,
    // transformRequest: [
    //     function(data) {
    //         let ret = ''
    //         for (let it in data) {
    //             ret +=
    //                 encodeURIComponent(it) +
    //                 '=' +
    //                 encodeURIComponent(data[it]) +
    //                 '&'
    //         }
    //         return ret
    //     }
    // ]
  }).then(res =>
    res);
};
export {
  loginreq,
  wjldc,
  req
}



// WEBPACK FOOTER //
// ./src/api/axiosFun.js